<!-- src/views/About.vue -->
<!-- eslint-disable -->
<template>
  <div class="container">

    <div class="container-box">
      <button @click="toggleContent" class="toggle-button">
        {{ isSearchVisible ? '▲' : '▼' }}
      </button>
      <transition name="slide">
        <div v-if="isSearchVisible" class="content-container">
          <div class="searchBox">
            <button @click="fetchVehicles">Fetch Vehicles</button>
            <select v-model="dataStore.selectedVehicles" multiple class="vehicle-select">
              <option v-for="vehicle in dataStore.vehicles" :key="vehicle" :value="vehicle">
                {{ vehicle }}
              </option>
            </select>
            <div class="content">
              <div class="search-table">
                <JourneySearchTable />
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>


    <div class="working-table">
      <JourneyWorkingTable />
    </div>

    <div class="events-map">
      <EventsMap />
    </div>

  </div>
</template>


<script setup>
/* eslint-disable */
import JourneySearchTable from '../components/JourneySearchTable.vue';
import JourneyWorkingTable from '../components/JourneyWorkingTable.vue';
import EventsMap from '../components/EventsMap.vue';
import { createDataStore } from '@/dataStore';
import { ref, provide } from 'vue';

const isSearchVisible = ref(true);
const dataStore = createDataStore({name:"VMTracking", dbname: "tracking"});

provide('datastore', dataStore);

async function fetchVehicles() {
  await dataStore.fetchVehicles();
}

const toggleContent = () => {
  isSearchVisible.value = !isSearchVisible.value;
};

</script>

<style>
.container {
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: 100%;
  height: 100%;
}

.searchBox {
  display: flex;
  flex-direction: row;
}

.vehicle-select {
  height: 150px;
}

.content {
  display: flex;
  flex-direction: column;
  flex: 2;
}

.search-table {
  max-height: 150px;
  overflow-y: auto;
}

.working-table {
  max-height: 150px;
  overflow-y: auto;
}

.events-map {
  flex: 1;
}

.btn-off {
  background-color: #ccc;
}

.btn-on {
  background-color: #4caf50;
}
</style>

<style scoped>
.content-container {
  overflow: hidden;
}

.slide-enter-active,
.slide-leave-active {
  transition: all 0.3s ease;
}

.slide-enter-from,
.slide-leave-to {
  max-height: 0;
  opacity: 0;
}

.slide-enter-to,
.slide-leave-from {
  max-height: 500px;
  /* Set this to a value large enough to fit your content */
  opacity: 1;
}
</style>
